package org.ecolution.webpage.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobwebx.markdown.*

@Page
@Composable
fun EnergieAargauPage() {
    org.ecolution.webpage.components.layouts.MarkdownLayout("Neues Energiegesetz 2025") {
        org.ecolution.webpage.components.widgets.EcoSpacer()
        org.jetbrains.compose.web.dom.H3(attrs = { id("neues-energiegesetz-ab-1-april-2025-ihre-roadmap-für-geak-plus-heizungsersatz") }) {
            org.jetbrains.compose.web.dom.Text("Neues Energiegesetz ab 1. April 2025: Ihre Roadmap für GEAK Plus & Heizungsersatz")
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("Ab dem 1. April 2025 gelten im Kanton Aargau neue Regeln für Energieeffizienz und Heizsysteme. Wer noch eine elektrische Widerstandsheizung oder eine alte Öl-/Gasheizung betreibt, sollte jetzt aktiv werden – die Fristen sind klar.")
        }
        org.jetbrains.compose.web.dom.H4(attrs = { id("geak-plus-pflicht-für-elektroheizungen") }) {
            org.jetbrains.compose.web.dom.Text("GEAK Plus‑Pflicht für Elektroheizungen")
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Em {
                org.jetbrains.compose.web.dom.Text("🏠 Wer ist betroffen?")
            }
            org.jetbrains.compose.web.dom.Text(" Alle Gebäude mit ortsfesten Elektro‑Widerstandsheizungen (zentral oder dezentral).")
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Em {
                org.jetbrains.compose.web.dom.Text("📅 Frist:")
            }
            org.jetbrains.compose.web.dom.Text(" Bis 31. März 2030 muss ein GEAK Plus erstellt werden.")
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Em {
                org.jetbrains.compose.web.dom.Text("💡 Warum GEAK Plus?")
            }
            org.jetbrains.compose.web.dom.Text(" Er zeigt den energetischen Zustand und liefert konkrete Sanierungsvorschläge inkl. Kosten-Nutzen-Analyse.")
        }
        org.jetbrains.compose.web.dom.H4(attrs = { id("heizungsersatz-in-altbauten") }) {
            org.jetbrains.compose.web.dom.Text("Heizungsersatz in Altbauten")
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Em {
                org.jetbrains.compose.web.dom.Text("🧾 Voraussetzung:")
            }
            org.jetbrains.compose.web.dom.Text(" Nachweis der GEAK‑Gesamtklasse D genügt für den Ersatz fossiler Heizsysteme.")
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Em {
                org.jetbrains.compose.web.dom.Text("🔧 Schritte zur Umsetzung:")
            }
        }
        org.jetbrains.compose.web.dom.Ol {
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("GEAK Plus erstellen (Pflicht & Nachweis in einem).")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Heizsystem wählen: Wärmepumpe, Pellets, Hybrid – oder fossile Lösung mit max. 90 % nicht erneuerbarer Energie (bei Wirtschaftlichkeitsnachweis).")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Kostennachweis einreichen, Gemeinde informieren.")
            }
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Em {
                org.jetbrains.compose.web.dom.Text("🎯 Vorteile:")
            }
        }
        org.jetbrains.compose.web.dom.Ul {
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Planungssicherheit durch klare Vorgaben")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Fördergelder für bis zu 12 Standardlösungen")
            }
        }
        org.jetbrains.compose.web.dom.H4(attrs = { id("weitere-neuerungen") }) {
            org.jetbrains.compose.web.dom.Text("Weitere Neuerungen")
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Em {
                org.jetbrains.compose.web.dom.Text("🚿 Kein rein elektrischer Wassererwärmer mehr")
            }
            org.jetbrains.compose.web.dom.Text(" → Wärmepumpenboiler sparen bis zu 65 % Strom.")
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Em {
                org.jetbrains.compose.web.dom.Text("📲 Digitale Energienachweise")
            }
            org.jetbrains.compose.web.dom.Text(" → Schnellere Meldung, weniger Papierkram.")
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Em {
                org.jetbrains.compose.web.dom.Text("📊 Neue Energiekennzahl")
            }
            org.jetbrains.compose.web.dom.Text(" → Mehr Freiheit bei der Wahl erneuerbarer Energieformen.")
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Em {
                org.jetbrains.compose.web.dom.Text("Quelle: ")
                com.varabyte.kobweb.silk.components.navigation.Link("https://www.ag.ch/de/verwaltung/bvu/energie/planung-und-energienachweise/gesetze-und-bauvorschriften/revidiertes-energiegesetz", "Kanton Aargau – Revidiertes Energiegesetz")
            }
        }
        org.jetbrains.compose.web.dom.H4(attrs = { id("so-unterstützt-ecolution-engineering") }) {
            org.jetbrains.compose.web.dom.Text("So unterstützt Ecolution Engineering")
        }
        org.jetbrains.compose.web.dom.Ol {
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Em {
                    org.jetbrains.compose.web.dom.Text("Gebäude-Check")
                }
                org.jetbrains.compose.web.dom.Text(" – Fällt Ihr Objekt unter das neue Gesetz?")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Em {
                    org.jetbrains.compose.web.dom.Text("GEAK Plus")
                }
                org.jetbrains.compose.web.dom.Text(" – Vom zertifizierten Experten.")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Em {
                    org.jetbrains.compose.web.dom.Text("Fördermittel")
                }
                org.jetbrains.compose.web.dom.Text(" – Wir beantragen, Sie profitieren.")
            }
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("👉 Jetzt anfragen")
            }
            org.jetbrains.compose.web.dom.Text(" – und die Pflicht stressfrei erfüllen!")
        }
        org.ecolution.webpage.components.widgets.BlogIntro(7)
        org.ecolution.webpage.components.widgets.EcoSpacer()
    }
}
